module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b84d093ed85484282118fdb25ce3e3f9.png";